module.exports = __webpack_public_path__ + "img/Angiogenesis-PDAC_GSE202740.dd429d36.png";